/* ============================================================
   v2 Arreglo Build — scroll-driven frame sequence
   - Vanilla JS, zero dependencies
   - Falls back to placeholder if frames are missing or
     reduced-motion is enabled
============================================================ */
(function () {
  'use strict';

  const MOBILE_BREAKPOINT = 768;
  const PRELOAD_CONCURRENCY = 6;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    if (reduceMotion) return;
    if (section.dataset.arregloInit === 'true') return;
    section.dataset.arregloInit = 'true';

    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    const frameCount = parseInt(
      isMobile ? section.dataset.frameCountMobile : section.dataset.frameCount,
      10
    ) || 0;
    const firstFrameUrl = isMobile
      ? section.dataset.firstFrameMobile
      : section.dataset.firstFrame;
    const prefix = isMobile
      ? section.dataset.framePrefixMobile
      : section.dataset.framePrefix;

    if (!frameCount || !firstFrameUrl || !prefix) return;

    const canvas = section.querySelector('[data-arreglo-canvas]');
    const loader = section.querySelector('[data-arreglo-loader]');
    const loaderFill = section.querySelector('[data-arreglo-loader-fill]');
    if (!canvas) return;

    const ctx = canvas.getContext('2d', { alpha: true });

    const urlFor = (n) => {
      const padded = String(n).padStart(3, '0');
      return firstFrameUrl.replace(prefix + '001', prefix + padded);
    };

    const probe = new Image();
    probe.decoding = 'async';
    probe.onload = () => bootSequence();
    probe.onerror = () => {
      // First frame missing → leave placeholder, no animation.
      // This is the "frames not uploaded yet" path.
      console.info('[v2-arreglo] frames not found, using placeholder only.');
    };
    probe.src = urlFor(1);

    function bootSequence() {
      section.classList.add('is-loading');
      const images = new Array(frameCount);
      let loaded = 0;
      let nextToLoad = 0;
      let firstDrawn = false;

      function updateLoader() {
        if (loaderFill) {
          loaderFill.style.width = Math.round((loaded / frameCount) * 100) + '%';
        }
      }

      function spawn() {
        while (nextToLoad < frameCount &&
               (nextToLoad - loaded) < PRELOAD_CONCURRENCY) {
          const idx = nextToLoad++;
          const img = new Image();
          img.decoding = 'async';
          img.onload = () => {
            images[idx] = img;
            loaded++;
            updateLoader();
            if (!firstDrawn && idx === 0) {
              firstDrawn = true;
              sizeCanvas(img);
              draw(0);
              section.classList.add('is-ready');
              attachScroll();
            }
            if (loaded === frameCount) {
              section.classList.remove('is-loading');
            }
            spawn();
          };
          img.onerror = () => {
            loaded++;
            updateLoader();
            spawn();
          };
          img.src = urlFor(idx + 1);
        }
      }

      let currentFrame = -1;
      let dpr = Math.min(window.devicePixelRatio || 1, 2);

      function sizeCanvas(sample) {
        const rect = canvas.getBoundingClientRect();
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(rect.width * dpr);
        canvas.height = Math.round(rect.height * dpr);
      }

      function draw(frameIdx) {
        const img = images[frameIdx];
        if (!img) {
          // fall back to the closest loaded frame
          for (let off = 1; off < frameCount; off++) {
            if (images[frameIdx - off]) { return draw(frameIdx - off); }
            if (images[frameIdx + off]) { return draw(frameIdx + off); }
          }
          return;
        }
        if (frameIdx === currentFrame) return;
        currentFrame = frameIdx;

        const cw = canvas.width;
        const ch = canvas.height;
        const iw = img.naturalWidth;
        const ih = img.naturalHeight;
        // Cover scaling: fill the canvas completely, cropping overflow
        const scale = Math.max(cw / iw, ch / ih);
        const w = iw * scale;
        const h = ih * scale;
        const x = (cw - w) / 2;
        const y = (ch - h) / 2;

        ctx.clearRect(0, 0, cw, ch);
        ctx.drawImage(img, x, y, w, h);
      }

      let scheduled = false;
      function onScroll() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          const scrollArea = section.querySelector('.v2-arreglo__scroll-area');
          if (!scrollArea) return;
          const rect = scrollArea.getBoundingClientRect();
          const vh = window.innerHeight;
          const total = rect.height - vh;
          const progress = Math.min(Math.max(-rect.top / total, 0), 1);
          const idx = Math.min(frameCount - 1, Math.floor(progress * (frameCount - 1)));
          draw(idx);
        });
      }

      function attachScroll() {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize, { passive: true });
        onScroll();
      }

      let resizeTimer;
      function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (images[0]) {
            sizeCanvas(images[0]);
            currentFrame = -1;
            onScroll();
          }
        }, 150);
      }

      spawn();
    }
  }

  function boot() {
    document.querySelectorAll('[data-v2-arreglo]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify theme editor section reload
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-v2-arreglo]');
    if (section) init(section);
  });
})();
